import { get, pick, map, sortBy, transform, flow, last } from 'lodash/fp';
import { generateUrlString } from './helpers';
import { STEPS } from '../constants';
import config from '../../config';


const paramsMap = {
  [STEPS.barber]: 'barberRoute',
  [STEPS.service]: 'serviceId',
  [STEPS.time]: 'reservationTime',
};

const getShopUrlAndParams = ({ shopRoute = ':shopRoute' }, urlPattern) => {
  const params = { shopRoute };
  const url = generateUrlString(params, urlPattern);
  return ({ params, url });
};
const makeUrlsArray = (params, urlPattern) => transform((result, step) => {
  const param = paramsMap[step.key];
  const newParams = {
    ...get('params')(last(result)),
    [param]: `:${param}`,
    ...pick(param)(params),
  };

  result.push({
    params: newParams,
    url: generateUrlString(newParams, urlPattern),
  });
}, [getShopUrlAndParams(params, urlPattern)]);

const addUrls = (params, urlPattern) => (steps) => {
  const urlsArray = makeUrlsArray(params, urlPattern)(steps);
  return map(step => ({ ...step, url: urlsArray.shift().url }))(steps);
};

const addTextValues = textValues => step => ({
  ...step,
  text: textValues[step.key],
});

const getFallbackText = (key) => {
  if (key === STEPS.barber) return 'Professional';
  if (key === STEPS.service) return 'Service';
  if (key === STEPS.time) return 'Time';
  if (key === STEPS.reservation) return 'Reserve';
  return null;
};

const addFallbackText = (step) => {
  if (step.text) return step;
  return { ...step, text: getFallbackText(step.key) };
};

const addTrimToService = step => ({
  ...step,
  trim: step.key === STEPS.service,
});

const transformStep = textValues => flow(
  addTextValues(textValues),
  addFallbackText,
  addTrimToService,
);

const orderFromUrlPattern = urlPattern =>
  flow(
    sortBy(step => urlPattern.toLowerCase().indexOf(step)),
    map(key => ({ key })),
  )([STEPS.barber, STEPS.service, STEPS.time]);

const addReserveStep = steps => [...steps, { key: STEPS.reservation }];

// eslint-disable-next-line import/prefer-default-export
export const generateSteps = (textValues, params, urlPattern = config.urlPatterns.old) =>
  flow(
    addReserveStep,
    addUrls(params, urlPattern),
    map(transformStep(textValues)),
  )(orderFromUrlPattern(urlPattern)) || [];



// WEBPACK FOOTER //
// ./src/app/utils/steps.js